import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const PlatformDistribution = () => {
  const [platformData, setPlatformData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPlatformData = async () => {
      try {
        const response = await api.get('/api/dashboard/platform-distribution');
        const result = response.data;
        console.log('Platform Distribution API Response:', result);
        if (result && result.success && result.data && Array.isArray(result.data)) {
          setPlatformData(result.data);
        } else {
          setPlatformData([]);
        }
      } catch (error) {
        console.error('Failed to fetch platform data:', error);
        setPlatformData([]);
      } finally {
        setLoading(false);
      }
    };
    fetchPlatformData();
  }, []);

  const total = platformData.reduce((sum, item) => sum + item.value, 0);

  if (loading) {
    return (
      <div className="dashboard-card distribution-card">
        <div className="card-body">
          <div className="card-header">
            <h3 className="card-title">Platform Distribution</h3>
            <p className="card-subtitle">Products listed by marketplace</p>
          </div>
          <div className="stacked-chart">
            <div className="platform-legend">
              <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                Loading...
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (platformData.length === 0) {
    return (
      <div className="dashboard-card distribution-card">
        <div className="card-body">
          <div className="card-header">
            <h3 className="card-title">Platform Distribution</h3>
            <p className="card-subtitle">Products listed by marketplace</p>
          </div>
          <div className="stacked-chart">
            <div className="platform-legend">
              <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                No data available yet
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-card distribution-card">
      <div className="card-body">
        <div className="card-header">
          <h3 className="card-title">Platform Distribution</h3>
          <p className="card-subtitle">Products listed by marketplace</p>
        </div>

        <div className="stacked-chart">
          <div className="stacked-bars">
            {platformData.map((platform, index) => (
              <div
                key={platform.name}
                className="stacked-bar"
                style={{
                  height: `${(platform.value / total) * 100}%`,
                  backgroundColor: platform.color,
                  animationDelay: `${index * 0.2}s`
                }}
                data-tooltip={`${platform.name}: ${platform.value}%`}
              ></div>
            ))}
          </div>

          <div className="platform-legend">
            {platformData.map((platform) => (
              <div key={platform.name} className="legend-item">
                <div
                  className="legend-color"
                  style={{ backgroundColor: platform.color }}
                ></div>
                <div className="legend-text">
                  <span className="legend-name">{platform.name}</span>
                  <span className="legend-value">{platform.value}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformDistribution;